export default __webpack_public_path__ + "static/media/idUpload.262569b9.jpg";